<template>
    <div class="text-h4 text-weight-bold" id="pageTitle"></div>
    <div class="q-py-xs" id="pageDescription" v-if="description"></div>
</template>

<style lang="less" scoped src="./action-page.less"></style>
<script lang="ts" src="./action-page.ts"></script>